export enum SedsLoadersCoreModeOptions {
  DETERMINATE = 'determinate',
  INDETERMINATE = 'indeterminate',
}
